const UpdateStatus = {
  UPDATE_SUCCESS: 1,
  UPDATE_PROCESSING: 2,
  UPDATE_FAILED: -1,
};

export default UpdateStatus;